// app/MetaPixelEvents.js
"use client";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

// Helper to fire fbq events safely
function fbqTrack(event, params) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", event, params);
  }
}

export default function MetaPixelEvents() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Track page view on route change
    fbqTrack("PageView");
    // Optionally, you can add custom logic for virtual pageviews here
  }, [pathname, searchParams]);

  return null;
}
